/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { renderRoutes } from 'react-router-config';
import NProgress from 'nprogress';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Boot as BootAction } from '@Actions';
import LayoutDefault from '@Layout/default';
import ConnexService from '@Api/connex';
import { platform } from '@Utils/connex';

NProgress.configure({
  showSpinner: false,
});

function App({ route }) {
  const location = useLocation();
  const dispatch = useDispatch();

  const config = useSelector((state) => state.getIn(['boot', 'config']), shallowEqual);

  useEffect(() => {
    if (config.size === 0) {
      dispatch(BootAction.fetchConfig());
    } else {
      ConnexService.getInstance(config.get('contractAddress'));
    }
  }, [config, dispatch]);

  useEffect(() => {
    if (platform().platform !== 'pc') {
      const viewport = document.querySelector('head meta[name="viewport"]');
      viewport.setAttribute('content', 'width=414, user-scalable=no');
    }
  }, []);

  useEffect(() => {
    NProgress.start();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0 });
    NProgress.done();
    return () => {
      NProgress.start();
    };
  }, [location]);

  return (
    <LayoutDefault>
      {platform().platform !== 'pc' && !location.pathname.includes('/m') && (
        <Redirect to={location.pathname === '/' ? '/m' : `/m${location.pathname}`} />
      )}
      {platform().platform === 'pc' && location.pathname.includes('/m') && (
        <Redirect
          to={location.pathname === '/m' ? '' : `${location.pathname.replace('/m', '')}`}
        />
      )}
      {renderRoutes(route.routes)}
    </LayoutDefault>
  );
}

export default App;
